import {
  AttachmentModel,
  AttachmentPreviewModel,
  AttachmentResponse,
  PreviewFromServer,
} from 'types';

import genericNormalizer, { normalizeDate } from './generic';

export const normalizePreview = genericNormalizer<
  PreviewFromServer,
  AttachmentPreviewModel
>(({ from }) => ({
  id: from('_id'),
  bytes: from('bytes'),
  height: from('height'),
  width: from('width'),
  scaled: from('scaled'),
  url: from('url'),
}));

export const normalizeAttachment = genericNormalizer<
  AttachmentResponse,
  AttachmentModel
>(({ from, has, map }) => ({
  date: has('date', normalizeDate),
  id: from('id'),
  isUpload: from('isUpload'),
  mimeType: from('mimeType'),
  name: from('name'),
  previews: map('previews', normalizePreview),
  url: from('url'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/attachment.ts